import HeaderModal from "../headerModal/headerModal";
import "./InformePDF.css";
import { useEffect, useState } from "react";

const InformePDFLabo = ({ titulo, dissmiss, base64, srcUrl, blob }) => {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    let objectUrl = null;
    if (srcUrl) {
      setUrl(srcUrl);
      return () => {};
    }
    if (blob) {
      objectUrl = URL.createObjectURL(blob);
      setUrl(objectUrl);
    } else if (base64) {
      const _blob = base64ToBlob(base64, "application/pdf");
      objectUrl = URL.createObjectURL(_blob);
      setUrl(objectUrl);
    }
    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [base64, srcUrl, blob]);

  function base64ToBlob(base64, type = "application/octet-stream") {
    const binStr = atob(base64);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      arr[i] = binStr.charCodeAt(i);
    }
    return new Blob([arr], { type: type, title: "InformeLabo" });
  }

  return (
    <div>
      {url ? (
        <>
          <HeaderModal titulo={titulo} dissmiss={dissmiss} />
          <iframe
            title="InformeLabo"
            className="ptur-misInformes-PDF"
            src={url}
            type="application/pdf"
          />
        </>
      ) : null}
    </div>
  );
};

export default InformePDFLabo;
